module.exports = __webpack_public_path__ + "media/images/plans/online/anymarry-spacemarket-logo-d4a84e5070c0eae14f89cbe6a30937ad.png";